import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { updatePartModelAsync, fetchPartModels, getPartModelsOverview } from '../../../store/Slices/PartModelSlice';
import { partModelValidationSchema } from '../../../utils/Schema';
import { partModelStatusOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const UpdatePartModelModal = ({ show, onHide, partModel, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { updatePartModelLoading } = useSelector((state) => state.partModels);

    const initialValues = {
        name: partModel?.name || '',
        status: partModel?.status || 'active'
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                id: partModel.id,
                ...values
            };
            await dispatch(updatePartModelAsync(payload)).unwrap();
            successNotify('Part model updated successfully');
            onHide();
            
            // Refresh table and overview
            dispatch(fetchPartModels({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getPartModelsOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Update Part Model" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={partModelValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Part Model Information</h5>
                            <div>
                                <Input
                                    label="Name"
                                    placeholder="Enter part model name"
                                    type="text"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                    touched={touched.name}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Status"
                                    placeholder="Select status"
                                    options={partModelStatusOptions}
                                    name="status"
                                    value={partModelStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={updatePartModelLoading || isSubmitting}
                                    disabled={updatePartModelLoading || isSubmitting}
                                    submitText="Update"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default UpdatePartModelModal;
